var v = (e) => {
  throw TypeError(e);
};
var f = (e, a, t) => a.has(e) || v("Cannot " + t);
var o = (e, a, t) => (f(e, a, "read from private field"), t ? t.call(e) : a.get(e)), m = (e, a, t) => a.has(e) ? v("Cannot add the same private member more than once") : a instanceof WeakSet ? a.add(e) : a.set(e, t), c = (e, a, t, r) => (f(e, a, "write to private field"), r ? r.call(e, t) : a.set(e, t), t);
import { B as g } from "./chunk-BaseElement-BuXbltG-.js";
import { n as u } from "./chunk-property-Baio2yOX.js";
var y = Object.defineProperty, n = (e, a, t, r) => {
  for (var i = void 0, h = e.length - 1, d; h >= 0; h--)
    (d = e[h]) && (i = d(a, t, i) || i);
  return i && y(a, t, i), i;
}, s;
const p = class p extends g {
  constructor() {
    super();
    m(this, s);
    this.multiple = !1, this._value = "", this.required = !1, this.pseudoChangeEventOnForm = !1, this._originalValue = "", c(this, s, this.attachInternals());
  }
  // Form controls usually expose a "value" property
  get value() {
    return this._value;
  }
  get _formValue() {
    if (this.multiple) {
      const t = this._value.split(","), r = new FormData();
      return t.forEach((i) => {
        r.append(this.name, i);
      }), r;
    }
    return this._value;
  }
  set value(t) {
    var i;
    const r = this._value;
    if (this._value = String(t), o(this, s).setFormValue(this._formValue), r !== this._value && (this.$emit("change", {
      value: this._formValue,
      previousValue: r
    }), this.pseudoChangeEventOnForm)) {
      const h = new CustomEvent("change", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          value: this._formValue,
          previousValue: r,
          submit: !0,
          name: this.name
        }
      });
      (i = this.form) == null || i.dispatchEvent(h);
    }
  }
  // The following properties and methods aren't strictly required,
  // but browser-level form controls provide them. Providing them helps
  // ensure consistency with browser-provided controls.
  get form() {
    return o(this, s).form;
  }
  get validity() {
    return o(this, s).validity;
  }
  get validationMessage() {
    return o(this, s).validationMessage;
  }
  get willValidate() {
    return o(this, s).willValidate;
  }
  checkValidity() {
    return o(this, s).checkValidity();
  }
  reportValidity() {
    return o(this, s).reportValidity();
  }
  formStateRestoreCallback(t) {
    t && (this.value = t);
  }
  formDisabledCallback(t) {
    this.disabled = t;
  }
  formResetCallback() {
    this.value = "";
  }
  resetValue() {
    this.value = this._originalValue;
  }
  firstUpdated(t) {
    super.firstUpdated(t), this._originalValue = this._value;
  }
};
s = new WeakMap(), p.formAssociated = !0, p.shadowRootOptions = {
  ...g.shadowRootOptions,
  delegatesFocus: !0
};
let l = p;
n([
  u({ type: Boolean })
], l.prototype, "multiple");
n([
  u({ type: String, attribute: "value", reflect: !0 })
], l.prototype, "_value");
n([
  u({ type: String, attribute: "name" })
], l.prototype, "name");
n([
  u({ type: Boolean, attribute: "disabled" })
], l.prototype, "disabled");
n([
  u({ type: Boolean })
], l.prototype, "required");
n([
  u({ type: String })
], l.prototype, "autocomplete");
n([
  u({ type: Boolean, attribute: "pseudo-change-event-on-form" })
], l.prototype, "pseudoChangeEventOnForm");
export {
  l as F
};
